module.exports = __webpack_public_path__ + "6df0958c1c5063fad1b7922c4bb4cd38.otf";